module.exports = __webpack_public_path__ + "img/061.66faafa6.png";